import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import CriarAmbiente from '../pages/CriarAmbiente';
import RevisarDados from '../pages/CriarAmbiente/RevisarDados';
import ListarTenants from '../pages/ListarTenants';
import Login from '../pages/Login';
import Route from './Route';

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={CriarAmbiente} isPrivate />
        <Route path="/gerenciar" exact component={ListarTenants} isPrivate />
        <Route path="/revisar-dados/:clienteId/:env" exact component={RevisarDados} isPrivate />

        <Route path="/login" component={Login} />
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;